// ===== 1. Imports =====
import React, { useEffect, useRef, useState } from "react";
import { FileText, FolderKanban, User } from "lucide-react";

// ===== 2. Componente Header =====
export default function Header({
  projectName,
  userName,
  department,
  setActiveTab,
  handleLogout,
  activeTab,
  userRole,
}) {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // ===== 3. Control del Menú de Usuario =====
  useEffect(() => {
    if (!userMenuOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    const handleEscape = (e) => e.key === "Escape" && setUserMenuOpen(false);
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [userMenuOpen]);

  // ===== 4. Tabs por Rol =====
  const superadminTabs = [
    { label: "PROYECTOS", icon: <FolderKanban size={15} /> },
  ];
  const adminTabs = [
    { label: "DASHBOARD" },
    { label: "PROVEEDORES" },
    { label: "PRESUPUESTO" },
    { label: "USUARIOS" },
    { label: "INFORMES" },
  ];
  const userTabs = [{ label: "DASHBOARD" }, { label: "PROVEEDORES" }];

  let tabs = [];
  if (userRole === "superadmin") tabs = superadminTabs;
  else if (userRole === "PM" || userRole === "Controller") tabs = adminTabs;
  else if (["HOD", "Coordinator", "Crew"].includes(userRole)) tabs = userTabs;

  // ===== 5. Render =====
  return (
    <header
      className="topbar"
      style={{
        borderBottom: "1px solid var(--ring)",
        padding: "6px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        {/* ==== LOGO Y NOMBRE ==== */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <img
            src="/media/LOGO_FILMA.png"
            alt="Logo Filma"
            style={{
              width: 90,
              height: "auto",
              objectFit: "contain",
            }}
          />
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "var(--fg)",
              padding: "4px 10px",
              border: "1px solid var(--ring)",
              borderRadius: 6,
              background: "transparent",
            }}
          >
            {userRole === "superadmin" ? "Superadmin" : projectName}
          </span>
        </div>

        {/* ==== MENÚ CENTRAL ==== */}
        <nav
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            alignItems: "center",
            gap: 22,
          }}
        >
          {tabs.map((tab) => (
            <a
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={activeTab === tab.label ? "active" : ""}
              style={{
                color: activeTab === tab.label ? "var(--accent)" : "inherit",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                padding: "3px 4px",
                transition: "color 0.2s ease",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: 6,
                lineHeight: 1,
              }}
            >
              {tab.icon && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transform: "translateY(-1px)",
                  }}
                >
                  {tab.icon}
                </span>
              )}
              <span>{tab.label}</span>
            </a>
          ))}
        </nav>

        {/* ==== USUARIO Y MENÚ ==== */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            position: "relative",
          }}
          ref={menuRef}
        >
          <div style={{ textAlign: "right" }}>
            <div style={{ fontWeight: 500, fontSize: 12, lineHeight: 1.1 }}>
              {userName}
            </div>
            {department && (
              <div
                style={{
                  fontSize: 10,
                  color: "var(--muted)",
                }}
              >
                {department}
              </div>
            )}
          </div>

          <button
            className="button"
            style={{
              height: 32,
              width: 32,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
            onClick={() => setUserMenuOpen((p) => !p)}
          >
            <User size={16} color="var(--fg)" />
          </button>

          {userMenuOpen && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 6px)",
                right: 0,
                background: "var(--bg)",
                border: "1px solid rgba(0,0,0,0.08)",
                borderRadius: 10,
                padding: 8,
                boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                zIndex: 1000,
                minWidth: 160,
              }}
            >
              <button
                className="button"
                style={{ width: "100%", justifyContent: "flex-start" }}
                onClick={handleLogout}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
